import React, { useState, useEffect, useContext } from 'react';
import { Card, Table, Button, Badge, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import AuthContext from '../../context/AuthContext';
import './Payments.css';

const Payments = () => {
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const response = await fetch('/api/payment-tracking/projects', {
        headers: {
          'x-auth-token': token
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch projects');
      }

      const data = await response.json();
      setProjects(data);
    } catch (err) {
      console.error('Error fetching projects:', err);
      toast.error('Failed to load projects with payment schedules');
    } finally {
      setIsLoading(false);
    }
  };

  const getPaymentStatusBadge = (received, total) => {
    if (received === total) {
      return <Badge bg="success">Complete</Badge>;
    } else if (received > 0) {
      return <Badge bg="warning">In Progress</Badge>;
    } else {
      return <Badge bg="secondary">Pending</Badge>;
    }
  };

  const formatCurrency = (value) => {
    if (value === null || value === undefined) return '$0.00';
    return `$${parseFloat(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  if (isLoading) {
    return <div className="text-center mt-5">Loading projects...</div>;
  }

  return (
    <div className="payments-container">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Payments</h2>
      </div>

      {projects.length > 0 ? (
        <Card>
          <Card.Body>
            <Table hover responsive>
              <thead>
                <tr>
                  <th>Project</th>
                  <th>Client</th>
                  <th>Payment Status</th>
                  <th>Amount Received</th>
                  <th>Total Amount</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {projects.map(project => (
                  <tr 
                    key={project.ProjectId} 
                    className="project-row"
                    style={{ cursor: 'pointer' }}
                    onClick={() => navigate(`/payments/${project.ProjectId}`)}
                  >
                    <td>
                      <div className="fw-bold">{project.ProjectName}</div>
                      <small className="text-muted">{project.ProjectStatus}</small>
                    </td>
                    <td>{project.ClientName}</td>
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        {getPaymentStatusBadge(project.ReceivedPayments, project.TotalPayments)}
                        <span className="text-muted small">
                          {project.ReceivedPayments} of {project.TotalPayments} payments received
                        </span>
                      </div>
                    </td>
                    <td className="text-success fw-bold">
                      {formatCurrency(project.ReceivedAmount)}
                    </td>
                    <td className="fw-bold">
                      {formatCurrency(project.TotalAmount)}
                    </td>
                    <td>
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/payments/${project.ProjectId}`);
                        }}
                      >
                        View Payments →
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      ) : (
        <Alert variant="info" className="text-center">
          <h5>No projects with payment schedules found</h5>
          <p className="mb-0">
            Create payment schedules for your projects to start tracking payments here.
          </p>
        </Alert>
      )}
    </div>
  );
};

export default Payments;
